import React from "react";

const TableDailyStatsComponent = ({ filters, handleToggleCheck, stats }) => {
  const { sore, stress, energy, mood, sleep } = filters;

  const Icon = ({ active, date }) => (
    <div>
      {date ? (
        <img alt="sort" src="/img/svg/up_down_arrows.svg" />
      ) : (
        <img
          alt="check"
          src={
            active
              ? "/img/svg/vuesax-linear-tick-square-checked.svg"
              : "/img/svg/vuesax-outline-tick-square.svg"
          }
        />
      )}
    </div>
  );

  const RowItem = ({ text, active }) => (
    <div
      className="head-item"
      onClick={() => handleToggleCheck(text.toLowerCase())}
    >
      {text === "Date" && <Icon active={active} date />}
      {text}
      {text !== "Score" && text !== "Date" && <Icon active={active} />}
    </div>
  );

  return (
    <section role="table-wrapper">
      <table role="report-table" className="readiness-rate">
        <thead role="table-header">
          <tr>
            <th>
              <RowItem text="Date" active={false} />
            </th>
            <th>
              <RowItem text="Sore" active={sore} />
            </th>
            <th>
              <RowItem text="Stress" active={stress} />
            </th>
            <th>
              <RowItem text="Energy" active={energy} />
            </th>
            <th>
              <RowItem text="Mood" active={mood} />
            </th>
            <th>
              <RowItem text="Sleep" active={sleep} />
            </th>
            <th>
              <RowItem text="Score" active={false} />
            </th>
          </tr>
        </thead>
        <tbody role="table-body">
          {stats.map((stat) => (
            <tr>
              <td>{stat.date}</td>
              <td>{stat.readiness[0]}</td>
              <td>{stat.readiness[1]}</td>
              <td>{stat.readiness[2]}</td>
              <td>{stat.readiness[3]}</td>
              <td>{stat.readiness[4]}</td>
              <td>
                <span>
                  {stat.readiness.reduce((prev, next) => prev + next)}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
};

export default TableDailyStatsComponent;
